import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ru from './translates/ru.json';
import en from './translates/en.json';
import es from './translates/es.json';
import ar from './translates/ar.json';
import langs_ru from './translates/langs.ru.json';
import langs_en from './translates/langs.en.json';
import countries_ru from './translates/countries.ru.json';
import countries_en from './translates/countries.en.json';
import {getLang} from "./modules/utils";

export const availableLanguages = ['en', 'es', 'ar']

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  ru:{
    translation: ru,
    langs: langs_ru,
    countries: countries_ru,
  },
  en: {
    translation: en,
    langs: langs_en,
    countries: countries_en,
  },
  ar: {
    translation: ar,
    langs: langs_en,
    countries: countries_en,
  },
  es: {
    translation: es,
    langs: langs_en,
    countries: countries_en,
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: 'en',
    lng: getLang(), // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option
    // defaultNS: 'ru',

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;